<div class="inner" [ngClass]="themeName" (mousedown)="$event.stopPropagation()">
	<div *ngFor="let option of options" (mouseup)="onOptionSelected(option, $event)" class="option">
		<span>
			<i *ngIf="option.icon" class="fa" [ngClass]="'fa-' + option.icon"></i>
			<span *ngIf="option.iconText" class="fa" class="icon-text">{{option.iconText}}</span>
			{{ option.label | translate }}
		</span>
	</div>
</div>
